export const num = (v: unknown): number => (typeof v === 'number' ? v : parseFloat(String(v)) || 0);

export const fmt = (v: number, d = 2): string =>
  v === 0 ? '-' : v.toLocaleString('ko-KR', { minimumFractionDigits: 0, maximumFractionDigits: d });
